import { useState } from "react";
import dayjs from "dayjs";

import { HotspotDistribution } from "./HotspotDistribution";
import { HotspotsPerDay } from "./HotspotsPerDay";
import { Filters } from "./Filters";
import { UsersPerDevice } from "./UsersPerDevice";
import { EngagementMap } from "./EngagementMap";

export const VirtualTour = () => {
  const [fromDate, setFromDate] = useState(
    dayjs(new Date()).subtract(7, "day").toDate()
  );
  const [toDate, setToDate] = useState(new Date());

  return (
    <>
      <div className="pb-4 mb-6 flex justify-end border-b border-borderColor">
        <Filters
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
        />
      </div>

      <div className="flex flex-wrap">
        <div className="w-full flex flex-wrap p-4 my-4 border border-borderColor rounded-lg relative">
          <div className="absolute bg-background-light px-4 -top-1rem left-0 ml-2 md:ml-4 font-light">
            Hotspots
          </div>
          <div className="w-full lg:w-1/2">
            <HotspotDistribution
              fromDate={fromDate}
              toDate={toDate}
              styles="lg:mr-2 h-full"
            />
          </div>
          <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
            <HotspotsPerDay
              fromDate={fromDate}
              toDate={toDate}
              styles="lg:ml-2 h-full"
            />
          </div>
        </div>
        <div className="w-full flex flex-wrap p-4 my-4 border border-borderColor rounded-lg relative">
          <div className="absolute bg-background-light px-4 -top-1rem left-0 ml-2 md:ml-4 font-light">
            Users
          </div>
          <div className="w-full lg:w-1/2">
            <UsersPerDevice
              fromDate={fromDate}
              toDate={toDate}
              styles="lg:mr-2 h-full"
            />
          </div>
          <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
            <EngagementMap
              fromDate={fromDate}
              toDate={toDate}
              styles="lg:ml-2 h-full"
            />
          </div>
        </div>
      </div>
    </>
  );
};
